import React, { SetStateAction, useEffect, useState } from "react";
import { PageTemplate } from "../../../../shared/layout/PageTemplate";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToast } from "../../../../shared/toasters/toasters";
import { ProductsService } from "../../../products/service";
import {
  IProducts,
  IProductsList,
  IProductValue,
} from "../../../products/dto/IProducts";
import { SingleValue } from "react-select";
import { ProductsAttributesActions } from "../../../products/attributes/components/ProductsAttributesActions";
import GalleryCardPreview from "../../../../shared/gallery/GalleryCardPreview";
import ImageContainer from "../../../../shared/gallery/ImageContainer";
// import DataFromExcel from "./DataFromExcel";

export const EditAttributesCrawled = () => {
  const tab = "BASE_DATA";
  const { state: pagination }: any = useLocation();
  const location = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [currentProduct, setCurrentProduct] = useState<IProductsList>();
  const handleSelectMainCategory = (
    selectedSingle: SingleValue<{ label: string; value: number }>,
    inputKey: string
  ) => {
    setCurrentProduct((prev: any) => ({
      ...prev,
      [inputKey]: selectedSingle?.value,
    }));
  };
  const navContent = () => {
    navigate(`/app/pending-products/crawled/content/${id}`, {
      state: pagination,
    });
  };
  const navBaseData = () => {
    navigate(`/app/pending-products/crawled/base-data/${id}`, {
      state: pagination,
    });
  };
  const changeValuesHandler = (values: any, attributeId: number) => {
    let tempArr: IProductValue[] = currentProduct?.values ?? [];
    const indexToReplace = tempArr?.findIndex(
      (attribute) => attribute.attribute === attributeId
    );
    const addId = values?.find((item: { isAdd: boolean }) => item.isAdd)
      ?.value as number;

    if (indexToReplace === -1) {
      tempArr?.push({
        attribute: attributeId,
        value: values
          ?.map((value: { value: number }) => value.value)
          .filter((item: number) => item !== addId),
      });
    } else {
      tempArr[indexToReplace] = {
        ...tempArr[indexToReplace],
        value: values
          ?.map((value: { value: number }) => value.value)
          .filter((item: number) => item !== addId),
      };
    }
    setCurrentProduct((prev: any) => ({ ...prev, values: tempArr }));
  };

  const handleClose = () => {
    navigate("/app/pending-products/crawled", {
      state: (location.state as any)?.pagination,
    });
    // navigate("/app/pending-products/imported", { state: { pagination: pagination?.pagination ?? {} } });
  };
  useEffect(() => {
    id &&
      tab &&
      ProductsService.getProductById(+id, tab)
        .then((response) => {
          setCurrentProduct(response);
        })
        .catch((error) => {
          ErrorToast(error);
          //novo
          navigate(-1);
        });
  }, [id]);
  // Base Data Update
  return (
    // <PageTemplate title={`${t("side_bar.crawled_product")}`}>
    <div className="col-12">
      <div className="page-title-box d-sm-flex align-items-center justify-content-between">
        <div className="d-flex align-itmes-end">
          <ul className="nav nav-pills nav-fill">
            {/* <li className="nav-item">
              <Link
                className="nav-link"
                to={`/app/pending-products/crawled/base-data/${id}`}
              >
                {t("products.base_data_update")}
              </Link>
            </li> */}
            <li onClick={() => navBaseData()}>
              <span className="nav-link cursor-pointer text-dark">
                {t("products.base_data_update")}
              </span>
            </li>
            <li>
              <span className="nav-link active">
                {t("products.attributes_update")}
              </span>
            </li>
            <li onClick={() => navContent()}>
              <span className="nav-link cursor-pointer text-dark">
                {t("products.content_update")}
              </span>
            </li>
            {/* <li>
              <Link
                className="nav-link"
                to={`/app/pending-products/crawled/content/${id}`}
              >
                {t("products.content_update")}
              </Link>
            </li> */}
          </ul>
        </div>
        <div
          className="alert alert-warning alert-dismissible shadow fade show m-0 pe-3"
          role="alert"
        >
          {currentProduct?.status}
        </div>
        <>
          <ul className="nav nav-pills">
            <li className="nav-item">
              <a
                rel="noreferrer"
                target="_blank"
                className="nav-link active"
                href={`${currentProduct?.crawlerUrl}`}
              >
                {t("crawlers.url")}
              </a>
            </li>
          </ul>
        </>
      </div>
      <div className="d-flex align-items-center justify-content-start">
        <button
          onClick={() => handleClose()}
          className="btn btn-info d-flex align-items-center mb-3"
        >
          <i className="ri-arrow-left-line me-1"></i>
          {t("products.back")}
        </button>
      </div>
      <div className="d-flex align-items-center mb-3">
        <div className="d-flex gap-3 align-items-center">
          <ImageContainer img={currentProduct?.productPictures ?? []} />
          {/* <GalleryCardPreview
            img={
              currentProduct?.productPictures[0]?.path ||
              "/images/jk-placeholder-image.jpg"
            }
          /> */}
          {/* <CustomImageHandler
            classes="avatar-lg rounded-circle me-2"
            path={currentProduct?.productPictures[1]?.path ?? ""}
            alt="User logo"
          /> */}
          <div>
            <h2>{currentProduct?.title}</h2>
            <p>{currentProduct?.eanCode}</p>
          </div>
        </div>
      </div>
      <ProductsAttributesActions
        productStaticts={{}}
        handleClose={handleClose}
        currentProduct={currentProduct as IProductsList}
        setCurrentProduct={
          setCurrentProduct as React.Dispatch<
            SetStateAction<IProductsList | IProducts>
          >
        }
        handleSelectMainCategory={handleSelectMainCategory}
        changeValuesHandler={changeValuesHandler}
      />
    </div>
    // </PageTemplate>
  );
};
